function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.9141 12.1604L26.9141 14.8518L-6.49194e-07 14.8518L-5.31549e-07 12.1604L26.9141 12.1604ZM2.69158 24.4637L2.69158 18.6964C2.69158 17.2662 3.93866 16.1973 5.38299 16.1973L21.5314 16.1973C22.9758 16.1973 24.2228 17.2662 24.2228 18.6964L24.2228 24.4637C24.2228 25.894 22.9758 26.9629 21.5314 26.9629L5.38299 26.9629C3.93865 26.9629 2.69158 25.894 2.69158 24.4637ZM21.5318 24.2712L21.5318 18.8884L5.38334 18.8884L5.38334 24.2712L21.5318 24.2712ZM3 8.26646L3 2.49916C3 1.06892 4.24707 -9.90802e-07 5.69141 -9.27668e-07L10.7378 -7.07087e-07C12.1821 -6.43953e-07 13.4292 1.06892 13.4292 2.49916L13.4292 8.26646C13.4292 9.69671 12.1821 10.7656 10.7378 10.7656L5.69141 10.7656C4.24707 10.7656 3 9.69671 3 8.26646ZM10.7378 8.07422L10.7378 2.69141L5.6914 2.69141L5.6914 8.07422L10.7378 8.07422ZM26.9141 31.0003L26.9141 28.3089L-1.23742e-06 28.3089L-1.35507e-06 31.0003L26.9141 31.0003Z",
  fill: "black"
});

var SvgShelving = function SvgShelving(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShelving, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shelving.c3679f0e.svg";
export { ForwardRef as ReactComponent };